import React from 'react';
import { Button, Card, Checkbox, Form, Input, Select, Space } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
  FIELD_TYPE_OPTIONS,
  FIELD_TYPE_PRESETS,
} from '../fieldTypePresets';

const { Option } = Select;

const AdminFormFieldsEditor = () => {
  return (
    <Form.List name="form_fields">
      {(fields, { add, remove }) => (
        <>
          {fields.map((fieldItem) => (
            <Card
              key={fieldItem.key}
              size="small"
              className="mb-3"
              title={`Trường ${fieldItem.name + 1}`}
              extra={
                <MinusCircleOutlined
                  onClick={() => remove(fieldItem.name)}
                  aria-label="Xóa trường"
                />
              }
            >
              <Form.Item
                noStyle
                shouldUpdate={(prev, cur) =>
                  prev.form_fields?.[fieldItem.name]?.type !==
                  cur.form_fields?.[fieldItem.name]?.type
                }
              >
                {({ getFieldValue, setFieldsValue }) => {
                  const type = getFieldValue(['form_fields', fieldItem.name, 'type']);
                  const isSchool = type === 'school';
                  const isRadio = type === 'radio';
                  const isExamDate = type === 'exam_date';
                  const showPlaceholder = !isSchool && !isExamDate && type !== 'date';

                  return (
                    <>
                      <Form.Item
                        label="Loại trường"
                        name={[fieldItem.name, 'type']}
                        rules={[{ required: true, message: 'Chọn loại' }]}
                      >
                        <Select
                          options={FIELD_TYPE_OPTIONS}
                          onChange={(value) => {
                            const preset = FIELD_TYPE_PRESETS[value] || FIELD_TYPE_PRESETS.text;
                            setFieldsValue({
                              form_fields: getFieldValue('form_fields').map((row, idx) =>
                                idx === fieldItem.name
                                  ? { ...preset, type: value }
                                  : row,
                              ),
                            });
                          }}
                        />
                      </Form.Item>
                      <Form.Item
                        label="Mã trường (name)"
                        name={[fieldItem.name, 'name']}
                        rules={[
                          { required: true, message: 'Nhập mã trường' },
                          {
                            pattern: /^[a-z][a-z0-9_]*$/,
                            message: 'Chữ thường, số, gạch dưới; bắt đầu bằng chữ',
                          },
                        ]}
                        extra={
                          isSchool
                            ? 'Trường trường học luôn dùng school_province, school_ward, school_name khi gửi form'
                            : undefined
                        }
                      >
                        <Input disabled={isSchool || isExamDate} />
                      </Form.Item>
                      <Form.Item
                        label="Nhãn hiển thị"
                        name={[fieldItem.name, 'label']}
                        rules={[{ required: true, message: 'Nhập nhãn' }]}
                      >
                        <Input />
                      </Form.Item>
                      {showPlaceholder && (
                        <Form.Item
                          label="Placeholder"
                          name={[fieldItem.name, 'placeholder']}
                        >
                          <Input />
                        </Form.Item>
                      )}
                      <Form.Item
                        name={[fieldItem.name, 'required']}
                        valuePropName="checked"
                      >
                        <Checkbox>Bắt buộc</Checkbox>
                      </Form.Item>

                      {isRadio && (
                        <Form.List name={[fieldItem.name, 'options']}>
                          {(options, { add: addOpt, remove: removeOpt }) => (
                            <>
                              <div className="mb-2">Các lựa chọn:</div>
                              {options.map((opt) => (
                                <Space key={opt.key} align="baseline" className="d-flex mb-2">
                                  <Form.Item
                                    name={[opt.name, 'value']}
                                    rules={[{ required: true, message: 'Giá trị' }]}
                                  >
                                    <Input placeholder="11" style={{ width: 100 }} />
                                  </Form.Item>
                                  <Form.Item
                                    name={[opt.name, 'label']}
                                    rules={[{ required: true, message: 'Nhãn' }]}
                                  >
                                    <Input placeholder="Lớp 11" />
                                  </Form.Item>
                                  {options.length > 1 && (
                                    <MinusCircleOutlined onClick={() => removeOpt(opt.name)} />
                                  )}
                                </Space>
                              ))}
                              <Button
                                type="dashed"
                                size="small"
                                onClick={() => addOpt()}
                                icon={<PlusOutlined />}
                              >
                                Thêm lựa chọn
                              </Button>
                            </>
                          )}
                        </Form.List>
                      )}

                      {isSchool && (
                        <>
                          <Form.Item
                            label="Nhãn Tỉnh/TP"
                            name={[fieldItem.name, 'labels', 'province']}
                          >
                            <Input />
                          </Form.Item>
                          <Form.Item
                            label="Nhãn Phường/Xã"
                            name={[fieldItem.name, 'labels', 'ward']}
                          >
                            <Input />
                          </Form.Item>
                          <Form.Item
                            label="Nhãn tên trường"
                            name={[fieldItem.name, 'labels', 'school']}
                          >
                            <Input />
                          </Form.Item>
                          <Form.Item
                            label="Placeholder tên trường"
                            name={[fieldItem.name, 'placeholders', 'school']}
                          >
                            <Input />
                          </Form.Item>
                        </>
                      )}
                    </>
                  );
                }}
              </Form.Item>
            </Card>
          ))}

          <Select
            placeholder="Thêm trường mới..."
            style={{ width: '100%', marginBottom: 8 }}
            value={undefined}
            onChange={(type) => {
              const preset = FIELD_TYPE_PRESETS[type] || FIELD_TYPE_PRESETS.text;
              add({ ...preset, type, required: preset.required !== false });
            }}
          >
            {FIELD_TYPE_OPTIONS.map((opt) => (
              <Option key={opt.value} value={opt.value}>
                {opt.label}
              </Option>
            ))}
          </Select>
        </>
      )}
    </Form.List>
  );
};

export default AdminFormFieldsEditor;
